class ImageLoader {

    image?: HTMLImageElement | null;

    constructor() {

    }

    loadImageDimensions(file: File): Promise<{ width: number, height: number }> {

        return new Promise(async (resolve, reject) => {

            let image = this.image;
            image = new Image();

            var url = URL.createObjectURL(file);

            image.onload = function () {
                resolve({width: image!.width, height: image!.height})
                // dispose the image
                image = null;
            };

            image.onerror = function (e) {
                reject(e)
            }

            image.src = url;

        })

    }
}

export default ImageLoader